
import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  colors,
} from "@mui/material";
import { Link } from "react-router-dom";

interface Report {
  name: string;
  description: string;
  path: string;
  module: string;
}

const reports: Report[] = [
  { name: "Tasks", description: "Detail of Task Report", module: "Tasks", path: "/reports/export-task_reprort" },
  // { name: "Tasks", description: "List of all retailers with details", module: "Tasks", path: "/reports/tasks" },
  // { name: "Retailers", description: "Summary of logged retailers", module: "Retailers", path: "/reports/retailersreports" },
  { name: "Rewards and points", description: "Report of earned and redeemed points", module: "Rewards", path: "/reports/rewards-pointsreports" },
  // { name: "Account Report", description: "Account Data", module: "Account", path: "/reports/reports-account" },
  { name: "IR Analysis", description: "IR Analysis Report", module: "Account", path: "/reports/basic-account-report" },
  { name: "Login & Otp Report", description: "Login & Otp Data", module: "Account", path: "/reports/login-otp-report" },
  { name: "Master User & Outlet Data", description: "Master Outer & Outlet Data", module: "Account", path: "/reports/master-report" },
];

const ReportsTable = () => {
  return (
    <Box sx={{ margin: "20px 32px" }}>
      <TableContainer component={Paper} sx={{ marginTop: 4, borderRadius: "10px", boxShadow: "none", border: "1px solid #c8c8c8" }}>
        <Typography variant="h6" sx={{ p: 2 }}>
          Reports
        </Typography>
        <Table>
          <TableHead sx={{ background: "#f5f5f5" }}>
            <TableRow sx={{ background: "#FFEBEF" }}>
              <TableCell><strong style={{color:"rgba(185, 0, 34, 1)"}}>Report Name</strong></TableCell>
              <TableCell><strong style={{color:"rgba(185, 0, 34, 1)"}}>Report Description</strong></TableCell>
              <TableCell><strong style={{color:"rgba(185, 0, 34, 1)"}}>Module</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reports.map((report, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Link
                    to={report.path}
                    style={{
                      textDecoration: "none",
                      color:"rgba(185, 0, 34, 1)",
                      fontWeight: 500,
                    }}
                  >
                    {report.name}
                  </Link>
                </TableCell>
                <TableCell>{report.description}</TableCell>
                <TableCell>{report.module}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ReportsTable;
